<template>
    <div id="CitationInvoiceTemplate">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Citation Invoice Detail</div>
                    <div class="btn-groups">
                        <button type="button" class="btn btn-tertiary" v-on:click="print()" > 
                            <i class="fp-print"> </i> Print
                        </button>
                        <button type="button" class="btn btn-tertiary" v-on:click="downloadPdf()" > 
                            <i class="fp-download"> </i> Download
                        </button>
                        <button type="button" class="btn btn-tertiary" v-on:click="backBtn()" > 
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content disposal-invoice-preview">
                        <div class="bg-white">
                            <div class="invoice-view-table" id="citation_invoice_content">
                                        
                            </div>
                        </div>
                    </div>                
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>        
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';


export default {
    name: "DisposalInvoiceTemplate",
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: "Disposal Invoice Preview | " +process.env.COPYRIGHT_NAME
    },
    
    mixins:[commonMixins],
    data: () => ({
        invoiceArr:[],
        loading:false,
        permissions:[],
        cantAccessPage:"",        
        invoiceId : 0,
        path:"",
        invoice_number:'',
        invoice_date:'',
        due_date:'',
        customer:'',
        terms:'',
        po_no:'',
        invoice_type:'',
        sub_total:'',
        tax_amount:'',
        total:'',
        invoiceItemsArr:[],
        cust_code:'',
        cust_name:'',

    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_invoice') {
                    self.cantAccessPage = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        self.invoiceId = this.$route.params.id;
        self.getPermissions();
        self.previewInvoice();
        self.path = process.env.API +  "/images/logo.png";
    },
    methods : {
        backBtn(){
            var self = this;
            self.$router.push("/citation-invoice/view/"+self.invoiceId);
        },
        downloadPdf() {
            var self = this;
            self.loading = true ;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/pdf",
                type: "POST",
                data: {
                    invoice_id:self.invoiceId,
                    invoice_type:"CIT",
                    invoice_origin:"system"
                },
                headers: this.ajxHeaders,
                dataType: 'json',
                success: function (data) {
                    self.loading = false ;
                    if (data.status == 'success'){
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data.content;
                        link.download = '';
                        link.target = "_blank";
                        link.click();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'rental-invoice-download');
                }
            });

        },
        previewInvoice() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/citation-invoice/preview",
                type: "GET",
                crossDomain: true,
                headers: this.ajxHeaders,
                data:{invoice_id:self.invoiceId,from:'preview'},
                dataType: "html",
                success: function(data) {
                    self.loading = false;
                    setTimeout(function(){
                        // $("#print_rental_content").html("");
                        $("#citation_invoice_content").html(data);
                    },300);
                  
                },
                error: function(jqXHR, exception) {
                    
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'citation-invoice-preview');
                }
            });
        },
        print() {
            var self = this;
            self.loading = true;
            var content = document.getElementById('citation_invoice_content').innerHTML;
            console.log(content);
            var link = window.open(content, '_blank');
            link.document.write(content);
            link.document.close();
            self.loading = false;
            link.print();
            link.close();

        }

    }    
}
</script>




// WEBPACK FOOTER //
// src/components/invoice/CitationInvoicePreview.vue